import { styled, ThemeOptions } from '@mui/material';
import React from 'react';
import { AnimationDot } from '../Animation';
import { ShoppingBagIcon } from '../../icons';

const TextButton = styled('div')(
  ({ textColor, fontSize, fontWeight }: { textColor: string; fontSize: number; fontWeight: string }) => ({
    color: textColor,
    fontSize: fontSize,
    fontWeight: fontWeight,
    cursor: 'pointer',
  }),
);

const CartCountContainer = styled('div')(({ bottomOffset, fontSize }: { bottomOffset: number; fontSize: number }) => ({
  position: 'absolute',
  bottom: +bottomOffset,
  fontSize: +fontSize,
  fontWeight: 600,
  lineHeight: 1.4,
}));

const CartCount = ({
  count,
  countNumber,
  bottomOffset,
  fontSize,
}: {
  count?: number;
  countNumber?: boolean;
  bottomOffset: number;
  fontSize: number;
}) => {
  if (!count || !countNumber) return null;
  return (
    <CartCountContainer bottomOffset={bottomOffset} fontSize={fontSize}>
      {count}
    </CartCountContainer>
  );
};

export const CustomDtcBagButton = ({
  cartCount,
  styleData,
  mobile,
  handleClick,
  dtc,
}: {
  cartCount?: number;
  styleData?: ThemeOptions;
  mobile?: boolean;
  handleClick?: () => void;
  dtc?: boolean;
}) => {
  const paramName = mobile ? 'bagButtonMobile' : 'bagButton';

  const customImage = dtc
    ? styleData?.inpageCheckoutComponent?.bagButton?.dtcImageUrl
    : styleData?.inpageCheckoutComponent?.bagButton?.imageUrl;
  const customSize = styleData?.inpageCheckoutComponent?.bagButton?.size ?? 25;

  const textButton = !!styleData?.inpageCheckoutComponent?.[paramName]?.textButton;

  const text = styleData?.inpageCheckoutComponent?.[paramName]?.text;
  const textColor = styleData?.inpageCheckoutComponent?.[paramName]?.textFontColor;
  const fontSize = styleData?.inpageCheckoutComponent?.[paramName]?.textFontSize;
  const fontWeight = styleData?.inpageCheckoutComponent?.[paramName]?.textFontWeight;

  const animationDot = !!styleData?.inpageCheckoutComponent?.[paramName]?.animationDot;

  const dotTopOffset = styleData?.inpageCheckoutComponent?.[paramName]?.animationDotYOffset || 0;
  const dotRightOffset = styleData?.inpageCheckoutComponent?.[paramName]?.animationDotXOffset || 0;
  const dotColor = styleData?.inpageCheckoutComponent?.[paramName]?.animationDotColor || '#ffffff';
  const dotSize = styleData?.inpageCheckoutComponent?.[paramName]?.animationDotSize || 8;

  const countNumber = styleData?.inpageCheckoutComponent?.[paramName]?.countNumber;
  const countNumberYOffset = styleData?.inpageCheckoutComponent?.[paramName]?.countNumberYOffset || 4;
  const countNumberSize = styleData?.inpageCheckoutComponent?.[paramName]?.countNumberSize || 8;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {textButton ? (
        <TextButton
          onClick={handleClick}
          fontSize={fontSize ? +fontSize : 20}
          fontWeight={fontWeight || 'normal'}
          textColor={textColor || '#ffffff'}
        >
          {cartCount ? `${text} (${cartCount})` : text}
        </TextButton>
      ) : (
        <div
          onClick={handleClick}
          style={{
            cursor: 'pointer',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: +customSize,
            height: +customSize,
          }}
        >
          {cartCount ? (
            <AnimationDot
              animationDot={animationDot}
              dotSize={dotSize}
              topOffset={dotTopOffset}
              rightOffset={dotRightOffset}
              dotColor={dotColor}
            />
          ) : null}
          <CartCount
            count={cartCount}
            countNumber={countNumber}
            bottomOffset={countNumberYOffset}
            fontSize={countNumberSize}
          />
          {customImage ? (
            <img
              src={customImage}
              alt="Bag Icon"
              style={{
                width: +customSize,
                height: +customSize,
                objectFit: 'contain',
              }}
            />
          ) : (
            <ShoppingBagIcon
              sx={{
                fontSize: +customSize,
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};
